
import React from "react";
import { Loader2, AlertCircle, FileWarning, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ChartLoadingStateProps {
  error?: boolean;
  errorMessage?: string;
  onRetry?: () => void;
  noData?: boolean;
  period?: string;
  isSearchingAlternative?: boolean;
}

export function ChartLoadingState({
  error = false,
  errorMessage = "Impossibile caricare i dati del grafico",
  onRetry,
  noData = false,
  period = "selezionato",
  isSearchingAlternative = false
}: ChartLoadingStateProps) {
  if (isSearchingAlternative) {
    return (
      <div className="flex flex-col items-center justify-center h-full w-full py-12">
        <Clock className="h-12 w-12 text-amber-500 animate-pulse mb-4" />
        <h3 className="text-lg font-semibold mb-2">Ricerca periodo alternativo</h3>
        <p className="text-center text-muted-foreground mb-6">
          Nessun dato disponibile per il periodo {period}.
          <span className="block mt-2">Ricerca automatica di dati disponibili in corso...</span>
        </p>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-full w-full py-12">
        <AlertCircle className="h-12 w-12 text-destructive mb-4" />
        <h3 className="text-lg font-semibold mb-2">Errore di caricamento</h3>
        <p className="text-center text-muted-foreground mb-6">{errorMessage}</p>
        {onRetry && (
          <Button variant="outline" onClick={onRetry}>
            Riprova
          </Button>
        )}
      </div>
    );
  }

  if (noData) {
    return (
      <div className="flex flex-col items-center justify-center h-full w-full py-12">
        <FileWarning className="h-12 w-12 text-amber-500 mb-4" />
        <h3 className="text-lg font-semibold mb-2">Nessun dato disponibile</h3>
        <p className="text-center text-muted-foreground mb-6">
          Non ci sono dati disponibili per il periodo {period}.
          {onRetry && <span className="block mt-2">Potrebbe essere necessario selezionare un altro periodo.</span>}
        </p>
        {onRetry && (
          <Button variant="outline" onClick={onRetry}>
            Ricarica dati
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-full w-full py-12">
      <Loader2 className="h-12 w-12 text-primary animate-spin mb-4" />
      <h3 className="text-lg font-semibold mb-2">Caricamento in corso</h3>
      <p className="text-center text-muted-foreground">
        Recupero dati dei prezzi...
      </p>
    </div>
  );
}
